import { Component } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import NavigationBar from "src/components/NavigationBar";
import AvatarsFlow from "src/modules/avatar/AvatarsFlow";
import AvatarSelector from "src/modules/avatar/components/AvatarSelector";
import ListButton from "src/components/ListButton";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { withPurchase } from "src/modules/purchase/PurchaseContext";
import {
  getDefaultAvatar,
  getAvatarById
} from "src/modules/avatar/duck/selectors";
import { setDeviceName } from "src/modules/device/ajax/cloud";
import MicSensitivity from "src/modules/station/enums/MicSensitivity";
import { withApp } from "src/components/App/Context";
import { H4 } from "src/atoms/typography";
import SoundAlertsSettings from "src/modules/sound-alerts/SoundAlertsSettings/";
import MotionDetectionSettings from "src/modules/motion-detection/MotionDetectionSettings";
import RenameDeviceDialog from "src/scenes/PairedDevices/components/RenameDeviceDialog";
import { motionStringKeys } from "src/modules/motion-detection/motionSensitivityOptions";
import { getPairedDevice } from "src/modules/device/duck/selectors";
import VideoSettings from "src/components/VideoSettings";
import EventsSettings from "src/components/EventsSettings";
import NoiseSensitivitySettings from "./NoiseSensitivitySettings";
import { getAppValue } from "src/utils/environment";
import { ReactComponent as MicrophoneIcon } from "./icons/microphone-outlined.svg";
import { ReactComponent as PawIcon } from "./icons/paw-outlined.svg";
import { ReactComponent as AlertsIcon } from "src/icons/sound-outlined.svg";
import { ReactComponent as StrollerIcon } from "./icons/stroller-outlined.svg";
import { ReactComponent as VideoOutlined } from "./icons/video-outlined.svg";
import { ReactComponent as EventsOutlined } from "./icons/events-outlined.svg";
import { ReactComponent as MotionBaby } from "./icons/motion-baby.svg";
import { ReactComponent as MotionDog } from "./icons/motion-dog.svg";
import { ReactComponent as PhoneIcon } from "./icons/phone-small.svg";
import { colorMap } from "src/modules/colors";

class Settings extends Component {
  state = {
    OpenedFlow: null,
    renderAvatarSelector: false,
    renderNoiseSensitivtySettings: false,
    renderMotionDetectionSettings: false,
    renderRenameDevice: false
  };

  getSelectedAvatarName() {
    const { avatar } = this.props;
    return avatar ? avatar.name : null;
  }
  openFlow = (Flow) => this.setState({ OpenedFlow: Flow });
  closeFlow = () => this.setState({ OpenedFlow: null });

  openAvatarSelector = () => this.setState({ renderAvatarSelector: true });
  closeAvatarSelector = () => this.setState({ renderAvatarSelector: false });

  openMotionDetectionSettings = () =>
    this.setState({ renderMotionDetectionSettings: true });
  closeMotionDetectionSettings = () =>
    this.setState({ renderMotionDetectionSettings: false });

  openNoiseSensitivitySettings = () =>
    this.setState({ renderNoiseSensitivtySettings: true });
  closeNoiseSensitivtySettings = () =>
    this.setState({ renderNoiseSensitivtySettings: false });

  openRenameDevice = () => this.setState({ renderRenameDevice: true });
  closeRenameDevice = () => this.setState({ renderRenameDevice: false });

  openAvatarsFlow = (initialStep = "avatars") => {
    this.setState({ renderAvatarSelector: false });
    this.openFlow((props) => (
      <AvatarsFlow
        initialStep={initialStep}
        shouldCloseOnSave={true}
        {...props}
      />
    ));
  };
  onMyAvatarButtonClick = () => {
    const { avatar } = this.props;
    avatar ? this.openAvatarSelector() : this.openAvatarsFlow("editor");
  };

  renameDevice = async (newDeviceName) => {
    const { app, jid } = this.props;
    try {
      await setDeviceName({
        xmppLogin: jid,
        deviceName: newDeviceName
      });
      app.synchronizer.announceItemChange(
        app.synchronizer.SynchronizableItems.DEVICES
      );
      app.synchronizer.synchronizeDevices();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  render() {
    const {
      OpenedFlow,
      renderAvatarSelector,
      renderNoiseSensitivtySettings,
      renderMotionDetectionSettings,
      renderRenameDevice
    } = this.state;
    const {
      t,
      onClose,
      displayMyAvatarButton,
      micSensitivity,
      motionSensitivity,
      supportsMotionDetection,
      isFreeVersion,
      purchase,
      avatar,
      isMultiRoom,
      device
    } = this.props;

    return OpenedFlow ? (
      <OpenedFlow onClose={onClose} onBack={this.closeFlow} />
    ) : (
      <>
        <RenameDeviceDialog
          isOpen={renderRenameDevice}
          onDismiss={this.closeRenameDevice}
          onRename={this.renameDevice}
          deviceName={device.name}
          originalDeviceName={device.originalName}
        />
        <NoiseSensitivitySettings
          isOpen={renderNoiseSensitivtySettings}
          onClose={this.closeNoiseSensitivtySettings}
        />
        <MotionDetectionSettings
          isOpen={renderMotionDetectionSettings}
          onClose={this.closeMotionDetectionSettings}
          remoteMotionSensitivity={motionSensitivity}
        />
        {renderAvatarSelector && (
          <AvatarSelector
            onClose={this.closeAvatarSelector}
            openFlow={() => this.openAvatarsFlow()}
            selectedAvatar={avatar}
          />
        )}
        <NavigationBar headingKey="settings" onClose={onClose} />
        <Box mt="16px" px="24px">
          <H4 color="highEmphasis" mb="8px">
            {t("parentStation.settings.currentMonitoring.heading")}
          </H4>
          <Flex justifyContent="space-between" flexWrap="wrap">
            <ListButton
              mb="16px"
              iconFill={colorMap.noiseSensitivity}
              width="280px"
              labelKey={"noiseSensitivity.heading"}
              icon={MicrophoneIcon}
              onClick={this.openNoiseSensitivitySettings}
              additionalText={t(MicSensitivity[micSensitivity].stringKey)}
            />
            {displayMyAvatarButton && (
              <ListButton
                mb="16px"
                iconFill={colorMap.avatars}
                width="280px"
                labelKey={"buttons.myDog"}
                icon={getAppValue({
                  barkio: PawIcon,
                  bibino: StrollerIcon
                })}
                additionalText={this.getSelectedAvatarName()}
                onClick={this.onMyAvatarButtonClick}
              />
            )}
            {supportsMotionDetection && (
              <ListButton
                mb="16px"
                iconFill={colorMap.motionDetection}
                width="280px"
                labelKey="motionDetection.heading"
                icon={getAppValue({
                  bibino: MotionBaby,
                  barkio: MotionDog
                })}
                onClick={() => this.openMotionDetectionSettings()}
                additionalText={t(motionStringKeys[motionSensitivity])}
              />
            )}
            {isMultiRoom && (
              <ListButton
                mb="16px"
                iconFill={colorMap.deviceName}
                width="280px"
                labelKey="placeholders.deviceName"
                icon={PhoneIcon}
                onClick={() => this.openRenameDevice()}
                additionalText={device.name}
              />
            )}
          </Flex>
          <H4 color="highEmphasis" mt="16px" mb="8px">
            {t("parentStation.settings.general.heading")}
          </H4>
          <Flex justifyContent="space-between" flexWrap="wrap">
            <ListButton
              mb="16px"
              iconFill={colorMap.alerts}
              width="280px"
              labelKey={"soundAlerts.heading"}
              icon={AlertsIcon}
              onClick={() => this.openFlow(SoundAlertsSettings)}
            />
            <ListButton
              mb="16px"
              iconFill={colorMap.videoSettings}
              width="280px"
              labelKey="videoSettings.heading"
              icon={VideoOutlined}
              onClick={() => this.openFlow(VideoSettings)}
            />
            <ListButton
              mb="16px"
              iconFill={colorMap.events}
              width="280px"
              labelKey="events.heading"
              icon={EventsOutlined}
              onClick={() =>
                isFreeVersion
                  ? purchase.open({ content: "events" })
                  : this.openFlow(EventsSettings)
              }
            />
          </Flex>
        </Box>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    isFreeVersion: isFreemium(state),
    avatar: getAvatarById(state, props.avatarId) || getDefaultAvatar(state),
    device: getPairedDevice(state, props.jid)
  };
}

const enhance = compose(
  withPurchase,
  withApp,
  withTranslation(),
  connect(mapStateToProps)
);

export default enhance(Settings);
